module.exports = __webpack_public_path__ + "cf73506836febb4d9401849c2903de71.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-jester-s.png
// module id = 2730
// module chunks = 0